"use client";
import { SectionItem } from "@/app/lib/features/home/home.types";
import Image from "next/image";
import Link from "next/link";
import { trackCategoryClick } from "@/app/lib/tracking/interactions";
import { useTrackView } from "@/app/hooks/useTrackView";

interface CategoryLinksSectionProps {
  categories: SectionItem[];
  sectionId?: number;
}

const CategoryLinksSection = ({ categories, sectionId }: CategoryLinksSectionProps) => {
  const trackRef = useTrackView("section", sectionId);

  if (!categories || categories.length === 0) {
    return null;
  }

  return (
    <div ref={trackRef} className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 sm:gap-4 lg:gap-6">
      {categories.map((category) => {
        const categoryName = category.name || category.title || "Kategori";

        const bgColor = category.background_color || "#f6f6f6";
        const textColor = category.text_color || undefined;
        const hotIcon = category.hot_icon || "/images/icons/hot.png";

        return (
          <Link
            key={category.id}
            href={category.slug || "#"}
            className="relative w-full font-medium rounded-full py-2 sm:py-3 px-2 sm:px-3 lg:px-2 flex items-center gap-3 sm:gap-4 lg:gap-6 border-2 hover:border-main transition-all duration-300 ease-in-out text-sm sm:text-base"
            onClick={() => { if (category.id) trackCategoryClick(category.id); }}
            style={{
              backgroundColor: bgColor,
              borderColor: bgColor,
              color: textColor,
            }}
          >
            <div className="relative w-10 h-10 sm:w-11.25 sm:h-11.25 lg:w-12.5 lg:h-12.5 rounded-full overflow-hidden shrink-0">
              <Image
                src={category.image}
                alt=""
                fill
                className="object-cover"
                sizes="(max-width: 640px) 40px, (max-width: 1024px) 45px, 50px"
                quality={70}
                loading="lazy"
                onError={(e) => {
                  e.currentTarget.style.opacity = "0";
                }}
              />
            </div>
            <span className="truncate">{categoryName}</span>
            {category.isHot && (
              <div className="absolute -top-2 right-4">
                <Image
                  src={hotIcon}
                  alt="Trend"
                  width={32}
                  height={17}
                  className="w-8"
                />
              </div>
            )}
          </Link>
        );
      })}
    </div>
  );
};

export default CategoryLinksSection;
